import React, { createContext, useContext, useState } from 'react'

const NavbarContext = createContext()

export function useNavbarContext() {
  return useContext(NavbarContext)
}

export function NavbarProvider({ children }) {
  const [isSelectedVariantsMode, setIsSelectedVariantsMode] = useState(false)
  const [isHpoPanelOpen, setIsHpoPanelOpen] = useState(false)
  const [isToolbarPanelOpen, setIsToolbarPanelOpen] = useState(false)
  const [isMultiSamplePanelOpen, setIsMultiSamplePanelOpen] = useState(false)
  const [sampleName, setSampleName] = useState(null)
  const [fileId, setFileId] = useState(null)
  const [handleCreatePdfFunc, setHandleCreatePdfFunc] = useState(() => () => {})
  const [isAnalysisReportAvailable, setIsAnalysisReportAvailable] = useState(false)
  const [variantData, setVariantData] = useState(null)
  const [currentFilters, setCurrentFilters] = useState(null)

  const value = {
    isSelectedVariantsMode,
    setIsSelectedVariantsMode,
    isHpoPanelOpen,
    setIsHpoPanelOpen,
    isMultiSamplePanelOpen,
    setIsMultiSamplePanelOpen,
    isToolbarPanelOpen,
    setIsToolbarPanelOpen,
    sampleName,
    setSampleName,
    handleCreatePdfFunc,
    setHandleCreatePdfFunc,
    fileId,
    setFileId,
    isAnalysisReportAvailable,
    setIsAnalysisReportAvailable,
    variantData,
    setVariantData,
    currentFilters,
    setCurrentFilters,
  }

  return <NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>
}
